import axiosInstant from "../../../../api";
import { uploadRequestEndpoint } from "../../../../api/endpoints";
import { IVideo } from "../hooks/useFetchVideos";
import { putToS3WithProgress } from "./putToS3";

const CONTENT_TYPE_BY_EXT: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    tif: "image/tiff",
    tiff: "image/tiff",
};

const contentTypeFromFile = (file: File): string => {
    if (file.type && Object.values(CONTENT_TYPE_BY_EXT).includes(file.type)) return file.type;
    const fromName = file.name.toLowerCase().match(/\.([a-z0-9]+)$/);
    return (fromName && CONTENT_TYPE_BY_EXT[fromName[1]]) || "image/jpeg";
};

// The API bumps thumbnail_count and signs
// `<video folder>/thumbnails/<hash>-v<version>-<count>.<ext>` in the video's
// own bucket; the client only chooses the image type.
export const uploadThumbnailToIconik = async (
    file: File,
    video: IVideo,
    onProgress?: (pct: number) => void,
): Promise<void> => {
    if (!video.id) {
        throw new Error("Video has no id; cannot upload thumbnail");
    }

    const contentType = contentTypeFromFile(file);
    const { data } = await axiosInstant.post(uploadRequestEndpoint(), {
        purpose: "thumbnail",
        fileId: video.id,
        contentType,
    });

    await putToS3WithProgress(data.signedRequest, file, contentType, {
        onProgress,
        headers: data.headers,
    });
};
